import React from 'react'
import Component from '../common/Component'
import HospitalIndemnityBenefitsSetComponent from './HospitalIndemnityBenefitsSetComponent'
import { benefitNames } from './hospitalIndemnityFields'
import BenefitsSetForm from '../BenefitsSet/BenefitsSetForm'

export default class HospitalIndemnityBenefitsSetForm extends Component {
  render() {
    return (
      <BenefitsSetForm
        benefitNames={benefitNames}
        benefitsSetComponent={HospitalIndemnityBenefitsSetComponent}
        productLine="Hospital Indemnity"
        {...this.props}
      />
    )
  }
}
